/* eslint-disable */
import React, { useState, useEffect, memo, useRef } from 'react'
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import * as API from "../../framework/API/api";
import { DateOnlyCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { useTranslation } from '../../locale/useTranslation';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import { utility } from '../../framework/utility/utilityProvider';
import moment from 'moment';
import { ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, TOAST_TYPES } from '../../framework/constant/constant';
import { MenuCommandCell } from '../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import BossDialog from '../../components/BossDialog';
import ToastNotification from '../../components/ToastNotification';
import { orderBy } from '@progress/kendo-react-data-tools';
import RefreshButton from '../../framework/forms/helpercomponents/buttons/RefreshButton';
import { Loader } from '../../framework/forms/helpercomponents/Loader';

const MediaEpisodeHistory = memo(({ selectedData, closeForm, showTitle, isFromContract, segment, isPopup = true, gridStyle = {}, currentDataItem }) => {
    const lang = useTranslation();

    const [gridData, setGridData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState(`${lang.data_loading_error_message}`);
    const [segmentTypeDataItem, setSegmentTypeDataItem] = useState({
        SID: 0,
        Description: "All"
    });
    const [segmentTypes, setSegmentTypes] = useState([]);
    const [disable, setDisable] = useState(false);
    // const [filterValue, setFilterValue] = useState({
    //     startDate: slotDate ? slotDate : moment(new Date()).subtract(7, 'days').format("YYYY-MM-DD"),
    //     endDate: slotDate ? slotDate : moment(new Date()).format("YYYY-MM-DD")
    // });
    const [filterValue, setFilterValue] = useState({
        startDate: currentDataItem ? moment(currentDataItem.SlotDateTime).subtract(7, 'days').startOf('day').format("YYYY-MM-DD") : moment().subtract(7, 'days').startOf('day').format("YYYY-MM-DD"),
        endDate: currentDataItem ? moment(currentDataItem.SlotDateTime).endOf('day').format("YYYY-MM-DD") : moment().endOf('day').format("YYYY-MM-DD")

    });
    const [sort, setSort] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        loadHistory();
    }, [selectedData, filterValue]);

    const loadHistory = async () => {

        setIsLoading(true);

        let data = Array.isArray(selectedData) ? selectedData : [selectedData];

        let segmentTypeRes = await API.getDataLookup(ENTITYNAME.SegmentType, { sort: { Description: 1 } });

        if (segment) {
            setSegmentTypeDataItem(segmentTypeRes.data.find((x) => x.SID == segment?.SegmentType?.SID));
            setDisable(true);
        }
        segmentTypeRes.data.unshift({ SID: 0, Description: "All" });
        setSegmentTypes(segmentTypeRes.data);

        let tempData = []
        let finalFilterValue = {
            ...filterValue,
            startDate: moment(filterValue?.startDate).valueOf(),
            endDate: moment(filterValue?.endDate).valueOf()
        };

        for (const element of data) {
            let res = await API.getMediaHistory(element, isFromContract ?? false, segment?._id, finalFilterValue);
            if (res.success) {
                tempData = [...tempData, ...res.data]
            }
            else {
                setLoadingStatus(`${lang.no_record_found_error_message}`);
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }

        }
        tempData.sort((a, b) => a.SlotDateTime - b.SlotDateTime);
        setGridData(() => tempData.map(data => {
            return {
                ChannelName: (data.Channel?.FullChannelName ?? data.Channel?.name ?? ""),
                ...data
            }
        }))
        setFilterData(() => tempData.map(data => {
            return {
                ChannelName: (data.Channel?.FullChannelName ?? data.Channel?.name ?? ""),
                ...data
            }
        }))
        if (gridData.length == 0) {
            setLoadingStatus(`${lang.no_record_found_error_message}`);
        }

        setIsLoading(false);

    }

    const downloadExcel = async () => {
        console.log(gridData.length == 0);
        if (gridData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.no_data_found_error_message });
            return;
        }

        let storeData = gridData.map(x => {
            return {
                Title: x.mediaEpisode.Title,
                Channel: x.ChannelName,
                SlotDate: moment(new Date(x.SlotDateTime)).format("YYYY-MM-DD"),
                SlotDate: utility.convertMilisecondsToDateString(x.SlotDateTime),
                SlotTime: utility.convertMilisecondsToStringWithFrames(x.SlotDateTime),
                ExhibitionNumber: x.ExhibitionNumber,
                RepeatNumber: x.RepeatNumber
            }
        })

        let res = await API.exportCSV(storeData);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const mediaHistoryMenuModel = (props) => {

        const menu = [
            {
                label: 'Options',
                items: [
                    { label: 'Go To Planning', icon: 'pi pi-fw pi-calendar', command: () => props.onGoToPlanning(props.dataItem) },
                    { label: 'Go To Scheduling', icon: 'pi pi-fw pi-server', command: () => props.onGoToScheduling(props.dataItem) },
                ]
            }
        ]
        return menu;
    }

    // open planning
    const onGoToPlanning = (props) => {
        let data = { planningdate: new Date(moment(props?.SlotDateTime)), channels: [props?.Channel] }
        utility.deleteSessionStorageItem(LOCALSTORAGE_KEY.planningPublishData);
        utility.setSessionValue(LOCALSTORAGE_KEY.planningPublishData, data);
        window.open(`/home/planning`, "_blank");
    }

    // open scheduling
    const onGoToScheduling = (props) => {
        utility.setSessionValue(
            LOCALSTORAGE_KEY.publishData,
            props
        );
        window.open(`/home/Scheduling`, "_blank");
    }

    const MyCommandCell = (props) => (

        <MenuCommandCell
            {...props}
            onGoToPlanning={onGoToPlanning}
            onGoToScheduling={onGoToScheduling}
            myMenuModel={mediaHistoryMenuModel}
        />
    );

    const onChange = (e) => {
        let tempData = [];
        if (e.target.value.SID == 0) {
            tempData = gridData;
        } else {
            tempData = gridData.filter((x) => x.segment?.SegmentType?._id == e.target.value._id);
        }
        setSegmentTypeDataItem(e.target.value);
        console.log(tempData);
        setFilterData(tempData);

    }

    const onRefresh = async () => {
        await loadHistory();
    };

    const lastSlotItem = filterData?.[filterData?.length - 1];

    const MyHistoryUI = () => (
        <div style={isPopup ? {} : { margin: "10px 5px" }}>
            <div style={{ display: "flex", alignItems: "flex-end", gap: "10px" }}>
                <div>
                    <label className="k-form-field ml-2 mt-1">{lang.start_date_label}: </label>
                    <input
                        type="date"
                        style={{ width: "130px" }}
                        className="form-control form-control-sm ml-1"
                        name="startDate"
                        value={filterValue.startDate}
                        onChange={(e) => setFilterValue({ ...filterValue, startDate: e.target.value })}
                    />
                </div>
                <div>
                    <label className="k-form-field ml-2 mt-1">{lang.end_Date_label}: </label>
                    <input
                        type="date"
                        style={{ width: "130px" }}
                        className="form-control form-control-sm ml-1"
                        name="endDate"
                        value={filterValue.endDate}
                        onChange={(e) => setFilterValue({ ...filterValue, endDate: e.target.value })}
                    />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <label className="k-form-field">{lang.segment_type_label} :</label>
                    <DropDownList
                        style={{ backgroundColor: "white", width: "130px" }}
                        data={segmentTypes}
                        name="SegmentType"
                        textField="Description"
                        dataItemKey="SID"
                        value={segmentTypeDataItem}
                        onChange={onChange}
                        disabled={disable}
                    />
                </div>
                <RefreshButton onClick={onRefresh} />
                {gridData.length > 0 && (<RoundButton icon="download" onClick={downloadExcel} title={lang.download_button_tooltip} style={{ marginTop: "2px", marginLeft: "-6px" }} />)}
            </div>
            <br />
            {isLoading ? (
                <div style={{ height: isPopup ? "50vh" : "71vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Loader />
                </div>
            ) : (
                <>
                    <Grid data={orderBy(filterData, sort)} style={{ height: isPopup ? "50vh" : "71vh", ...gridStyle }} sortable={true} sort={sort} onSortChange={(e) => { setSort(e.sort); }}>
                        <GridNoRecords>{loadingStatus}</GridNoRecords>
                        {segment && <Column cell={MyCommandCell} width={"55px"} />}
                        <Column field="CSID" title={lang.transmission_id_label} width={150} />
                        <Column field="mediaEpisode.Title" title={lang.title_column} width={150} sortable={true} />
                        <Column field="ChannelName" title={lang.channel_column} width={150} sortable={true} />
                        <Column field="segment.SegmentType.Description" title={lang.segemnt_type_sub_menu} width={120} />
                        <Column field="SlotDateTime" title={lang.slot_date_column} cell={DateOnlyCell} width={100} sortable={true} />
                        <Column field="SlotDateTime" title={lang.slot_time_column} cell={TimeCell} width={100} sortable={true} />
                        <Column field="ExhibitionNumber" title={lang.exhibition_no_column} />
                        <Column field="RepeatNumber" title={lang.repeat_no_column} />
                    </Grid>
                    <div className='row'>
                        <div className='col-md-12' style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ marginTop: '10px', fontSize: "12px" }}>
                                {lang.last_air_time_label} : {lastSlotItem?.ChannelName || '-'}, {""}
                                {lastSlotItem?.SlotDateTime ? utility.convertMilisecondsToDateTimeString(lastSlotItem?.SlotDateTime) : '-'}
                            </div>
                            <div style={{ marginTop: '10px', fontSize: "12px" }}>
                                {lang.total_count_label} : {filterData?.length ?? 0}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
    return (
        <>
            {
                isPopup ? <BossDialog
                    title={lang.history_dialog_header}
                    onClose={closeForm}
                    width={"50%"}
                >
                    <MyHistoryUI />
                </BossDialog> : <MyHistoryUI />
            }
        </>

    )
});

export default MediaEpisodeHistory;